import React from 'react'
// import ReactWOW from 'react-wow/src'

const Article = ({title, text}) => {

  return (
    <div className='col-12 col-lg-6'>
      <div className='Blog-box'>
        <div className='wrapper'>
          <h3 className='Blog-box__title'>{title}</h3>
          <p className='Blog-box__text'>{text}</p>
          <a className='Blog-box__link' href='/'>
            <span>M</span>
            <span className='text-decor'>Read on Medium</span>
            <span className='arrow'></span>
          </a>
          <p className='Blog-box__time'>
            <span>15 min read</span>
            <span>May 24. 2020</span>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Article